<template>
  <div id="home" class="page">
    <h1><img src="../assets/fci-logo.svg" alt="株式会社未来演算研究所"></h1>
    <p class="note">{{ msg }}</p>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: '株式会社未来演算研究所は、未来を演算する研究をしている会社です。'
    }
  }
}
</script>

<style scoped lang="scss">
#home {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  h1 {
    img {
      width: 30vw;
      min-width: 240px;
    }
  }

  .note {
    font-size: 0.8rem;
    color: rgba(0,0,0,0.6);
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue